import { render, staticRenderFns } from "./CustomEventListItem.vue?vue&type=template&id=3a69529d&scoped=true&"
import script from "./CustomEventListItem.vue?vue&type=script&lang=js&"
export * from "./CustomEventListItem.vue?vue&type=script&lang=js&"
import style0 from "./CustomEventListItem.vue?vue&type=style&index=0&id=3a69529d&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3a69529d",
  null
  
)

export default component.exports